// Unified case studies data
export const caseStudies = [
  {
    id: '1',
    companyName: '株式会社ペッツオーライ様',
    logoText: 'PetzAllRight',
    summary: '採用率1〜2％ → 66％に改善。質の高い人材の獲得に成功。',
    result: { before: '1〜2％', after: '66％' },
    tags: ['採用効率化', 'OSUMITSUKI'],
    interviewer: '代表取締役社長 小早川様',
    imageUrl: '/images/jirei1.jpg',
    companyDescription: '業界の接点とテクノロジーを活用することで、業界の課題を「仕組み」で解決することを目指した会社です。ペットライフを豊かにするサービスを展開し、専門家相談サービス「ペッツオーライ」やわんことのお出かけ支援サービス「Wan!Pass」など、ペットオーナーの声から生まれたサービスを提供しています。',
    sections: [
      { title: '導入前の課題', question: 'どのような課題がありましたか？', answer: '応募者の本質的な適性が見えにくく、内定率が低迷していた。' },
      { title: '導入の決め手', question: '導入を決めた理由は？', answer: '共通の評価基準に基づくスコアリングにより、判断のばらつきが減ると感じたため。' },
      { title: '導入後の効果', question: 'どのような効果がありましたか？', answer: '採用率が大幅に改善し、面接時間の削減にもつながった。' }
    ]
  },
  {
    id: '2',
    companyName: '株式会社スマレジ様',
    logoText: 'Smaregi',
    summary: '内定率33% 自社面接よりも高い内定率で紹介した6名中2名が内定',
    result: { before: '-', after: '内定率33%' },
    tags: ['面接効率化', 'OSUMITSUKI'],
    interviewer: '執行役員 営業本部長 杉本様',
    imageUrl: '/images/jirei2.jpg',
    companyDescription: 'スマレジ株式会社は、POSシステム「スマレジ」、決済サービス「PAYGATE」、HRサービス「スマレジ・タイムカード」、SES事業「スマレジ・テックファーム」、CVC事業「スマレジ・ベンチャーズ」など、小売・飲食業界を中心とした多様な事業を展開しています。',
    sections: [
      { title: '自社の面接と比較して', question: 'Q. 自社の面接と比較してどうでしたか？', answer: '現場が忙しく大変な状況だったため1次面接を通しがちでした。また、社内の面接は内容を議事録的にテキストとして残しているだけだったので評価が定量化されていませんでした。OSUMITSUKI経由の面接は点数で定量的に表現されているので分かりやすくとても助かっています。' },
      { title: '他サービスとの違い', question: 'Q. 他サービスとの違いはどうですか？', answer: '転職エージェント経由の紹介は候補者の良い箇所だけを書く傾向がある中、OSUMITSUKIでは懸念点含め良い所も悪い所もしっかりと記載されているため候補者のフィルターがきちんとかかっていると実感できます。' }
    ]
  },
  {
    id: '3',
    companyName: 'HRテクノロジーズ株式会社様',
    logoText: 'HR Tech',
    summary: '中立的な評価が採用判断の質を高めた。',
    result: { before: '-', after: '判断精度向上' },
    tags: ['中立評価', 'OSUMITSUKI'],
    interviewer: '代表取締役社長 鈴木様',
    imageUrl: '/images/jirei3.jpg',
    companyDescription: '頑張る人が自己実現できるような社会にするために、テクノロジーを通して新しい仕組みを生み出していきます。「なりたい自分に出会う。」をコンセプトに、セールス職に特化した求人プラットフォーム「Sales Agent」、転職支援サービス「ソクテン」、キャリア支援サービス「スパルタキャリア」などを展開しています。',
    sections: [
      { title: '自社の面接と比較して', question: 'Q. 自社の面接と比較してどうでしたか？', answer: '面接評価がかなり的確でした。良いところだけではなく気になる箇所のフィードバックを中立の立場で貰えたため、採用する側からすると貴重な意見でした。候補者の懸念ポイントを事前に教えてもらえているので、面接時にそれをチェックしてズレがないかを確認できました。' },
      { title: '他サービスとの違い', question: 'Q. 他サービスとの違いはどうですか？', answer: '候補者の悪いところ、気になる箇所も教えてくれる事です。私達自身もエージェントをやっていますが、紹介企業にはつい良いところだけ教えてしまいがちになってしまいます。そこを良いところだけではなく気になるところも聞けている、聞きたいことを事前に全て聞けている状態なので面接時間自体もかなり減らせています。' }
    ]
  },
  {
    id: '4',
    companyName: '株式会社2PEACE様',
    logoText: '2PEACE',
    summary: '受注件数156%達成・平均単価9倍。6ヶ月で総売上1.1億円を実現。',
    result: { before: '平均単価80万円', after: '740万円（9倍）' },
    tags: ['育成', 'スキルの拡張パック'],
    interviewer: '役員 金本様',
    imageUrl: '/images/jirei4.jpg',
    companyDescription: '転職エージェント事業、RPO事業を展開。未資格・未経験でも挑戦できる採用方針のもと、教育制度の構築に注力。従業員約10名の組織で、幹部中心から従業員ベースの受注体制へのシフトを実現。OSUMITSUKIを6ヶ月導入し、RPO受注14件・総売上1.1億円を達成。',
    sections: [
      {
        title: '導入前の課題',
        question: 'Q. どのような課題がありましたか？',
        answer: '幹部中心の営業体制から従業員ベースでの受注体制へのシフトが急務でした。しかし育成を任せられるマネジメント人材が不足しており、上司のスキルに依存した教育では品質にばらつきがありました。社内の評価軸だけでは成長の妥当性を判断できず、「何をどう教えればいいのか分からない」状態でした。'
      },
      {
        title: '導入の決め手',
        question: 'Q. 外部サービスを選んだ理由は？',
        answer: '社内育成には3つの構造的な限界がありました。評価基準の属人化、育成の再現性の低さ、そして内発的動機の引き出しにくさです。外部の第三者だからこそ本音で向き合え、社内の利害関係なく本当の課題に向き合える点が決め手でした。上司に相談するのは「悪」と感じていたメンバーも、第三者には本音を話せるようになりました。'
      },
      {
        title: '導入後の効果',
        question: 'Q. 6ヶ月でどのような成果がありましたか？',
        answer: 'RPO受注件数は目標9件に対し実績14件で156%達成。平均受注単価は80万円から740万円（最大2,000万円）に向上し、総売上は1.1億円を達成しました。営業効率もアポ数40→20に減少しながら成果は倍増。3ヶ月目には投資回収が完了しました。定性面では「なんとなく仕事をする」状態がなくなり、週次で目的が明確になったことでメンバーの行動が大きく変わりました。'
      },
      {
        title: 'サービスの特徴',
        question: 'Q. 他のサービスとの違いは何ですか？',
        answer: '研修だとその時やったことが仕事に活きる感覚にならないのに対し、スキルの拡張パックは宿題が日常の業務につながる感覚になります。週次60分の1on1で「自分で考え行動できる力」を鍛えるため、サービス終了後も習慣が残ります。勝手にコンセプトをつけさせてもらうなら、「最も身近な第三者」というコンセプトです。特に幹部候補は絶対に受けるべきだと思います。'
      }
    ]
  }
];

// Placeholder count for future additions (render empty boxes)
export const caseStudyPlaceholders = 0;


